/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import IdentityModel from 'cio/models/identity';

interface SendingDomainsDynamicIdentitiesArgs {
  identities: IdentityModel[];
  identitiesInUse: IdentityModel[];
  onUpdateIdentity: () => unknown;
}

export default class SendingDomainsDynamicIdentities extends Component<SendingDomainsDynamicIdentitiesArgs> {
  @tracked isAddingFromAddress = false;

  get hasDynamicIdentities() {
    return this.args.identities?.length > 0;
  }

  @action
  async onSaveIdentity() {
    await this.args.onUpdateIdentity();
    this.isAddingFromAddress = false;
  }
}
